import { Box, Circle, HStack } from "@chakra-ui/react";
import {
  Carousel,
  CarouselIconButton,
  CarouselSlide,
  useCarousel,
} from "@ui/components/carousel";
import { useState } from "react";
import { IoChevronBackOutline, IoChevronForwardOutline } from "react-icons/io5";
import { QuickFact } from "./quick-fact";
import { QuickFactsRendererProps } from "./renderer";

export interface QuickFactsMobileCarouselProps
  extends QuickFactsRendererProps {}

export const QuickFactsMobileCarousel = ({
  facts,
}: QuickFactsMobileCarouselProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [ref, slider] = useCarousel({
    slideChanged: (slider) => setCurrentSlide(slider.track.details.rel),
  });

  const hasPrevious = currentSlide !== 0;
  const hasNext = currentSlide < facts?.length - 1;
  return (
    <Box
      position="relative"
      sx={{
        _hover: {
          "> button": {
            display: "inline-flex",
          },
        },
      }}
    >
      <Carousel ref={ref}>
        {facts?.map((fact, idx) => {
          return (
            <CarouselSlide key={idx}>
              <QuickFact {...fact} mx="auto" my="6" />
            </CarouselSlide>
          );
        })}
      </Carousel>
      {hasPrevious && (
        <CarouselIconButton
          pos="absolute"
          left="3"
          top="50%"
          transform="translateY(-50%)"
          hoverColor="blue.600"
          activeColor="blue.600"
          onClick={() => slider.current?.prev()}
          icon={<IoChevronBackOutline />}
          aria-label="Previous Slide"
        />
      )}

      {hasNext && (
        <CarouselIconButton
          pos="absolute"
          right="3"
          top="50%"
          transform="translateY(-50%)"
          hoverColor="blue.600"
          activeColor="blue.600"
          onClick={() => slider.current?.next()}
          icon={<IoChevronForwardOutline />}
          aria-label="Next Slide"
        />
      )}
      <HStack position="absolute" width="full" justify="center" bottom="0">
        {facts?.map((_, index) => (
          <Circle
            key={index}
            size="2"
            bg={currentSlide === index ? "blue.600" : "blue.200"}
          />
        ))}
      </HStack>
    </Box>
  );
};
